import { Routes, Route } from 'react-router-dom'

import SignIn from '../pages/SignIn';
import PrimeiroAcesso from '../pages/SignIn/acesso.js';

import Home from '../pages/Home';
import Calendario from '../pages/Calendario';

import Relatorio from '../pages/Relatorio/register.js';
import RelatorioList from '../pages/Relatorio/index.js';
import RelatorioEdit from '../pages/Relatorio/edit.js';

import User from '../pages/User';
import UserNew from '../pages/User/register.js';
import UserEdit from '../pages/User/edit.js';

import Cidade from '../pages/Cidade'
import CidadeNew from '../pages/Cidade/register.js'
import CidadeEdit from '../pages/Cidade/edit.js'

import Cargo from '../pages/Cargo'
import CargoNew from '../pages/Cargo/register.js'
import CargoEdit from '../pages/Cargo/edit.js'

import Igreja from '../pages/Igreja'
import IgrejaNew from '../pages/Igreja/register.js'
import IgrejaEdit from '../pages/Igreja/edit.js'

import Log from '../pages/pages/log.js'
import LogPrimeiroAcesso from '../pages/pages/primeiro-acesso.js'


import Private from './Private'
import Error from '../pages/pages/erro.js';
import AcessoNegado from '../pages/pages/acesso_negado.js';

function RoutesApp() {
  return (
    <Routes>
      <Route path="/" element={<SignIn />} />
      <Route path="/primeiro-acesso" element={<PrimeiroAcesso />} />

      <Route path="/home" element={<Private requiredPermissions="home"> <Home /> </Private>} />
      <Route path="/calendario" element={<Private requiredPermissions="calendario"> <Calendario /> </Private>} />

      <Route path="/relatorio" element={<Private requiredPermissions="relatorio_lista"> <RelatorioList /> </Private>} />
      <Route path="/relatorio/new" element={<Private requiredPermissions="relatorio_novo"> <Relatorio /> </Private>} />
      <Route path="/relatorio/edit/:id" element={<Private requiredPermissions="relatorio_editar"> <RelatorioEdit /> </Private>} />

      <Route path="/user" element={<Private requiredPermissions="usuario_lista"> <User /> </Private>} />
      <Route path="/user/new" element={<Private requiredPermissions="usuario_novo"> <UserNew /> </Private>} />
      <Route path="/user/edit/:id" element={<Private requiredPermissions="usuario_editar"> <UserEdit /> </Private>} />

      <Route path="/cidade" element={<Private requiredPermissions="cidade_lista"> <Cidade /> </Private>} />
      <Route path="/cidade/new" element={<Private requiredPermissions="cidade_novo"> <CidadeNew /> </Private>} />
      <Route path="/cidade/edit/:id" element={<Private requiredPermissions="cidade_editar"> <CidadeEdit /> </Private>} />

      <Route path="/cargo" element={<Private requiredPermissions="cargo_lista"> <Cargo /> </Private>} />
      <Route path="/cargo/new" element={<Private requiredPermissions="cargo_novo"> <CargoNew /> </Private>} />
      <Route path="/cargo/edit/:id" element={<Private requiredPermissions="cargo_editar"> <CargoEdit /> </Private>} />

      <Route path="/igreja" element={<Private requiredPermissions="igreja_lista"> <Igreja /> </Private>} />
      <Route path="/igreja/new" element={<Private requiredPermissions="igreja_novo"> <IgrejaNew /> </Private>} />
      <Route path="/igreja/edit/:id" element={<Private requiredPermissions="igreja_editar"> <IgrejaEdit /> </Private>} />

      <Route path="/log" element={<Log />} />
      <Route path="/pa" element={<LogPrimeiroAcesso />} />


      <Route path="acesso_negado" element={<AcessoNegado />} />
      <Route path="*" element={<Error />} />

    </Routes>
  )
}

export default RoutesApp;